module.exports = __webpack_public_path__ + "static/media/delete-inactive-button.727ecd2a.svg";